module.exports = __webpack_public_path__ + "static/dagny-bolditalic-f449209e225d3366a207802e31bebff5.woff2";